"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_WatchThemDie_OnEnemyKilledEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_WatchThemDie_OnEnemyKilledEventHandlerScript = class Effect_WatchThemDie_OnEnemyKilledEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.EnemyKilled) {
            return;
        }
        for (const attribute of handler.args.scriptArgs.attributes) {
            const scoreIncrease = container.getPercentOfBaseAttributeScore(handler.subject, handler.args.scriptArgs.attributeIncreasePercent, attribute);
            container.applyBuff({
                sequence,
                creatorId: handler.subject,
                targetId: handler.subject,
                effect: new __1.MaxAttributeIncreaseEffectArgs(attribute, scoreIncrease),
                duration: Duration_1.Duration.Instant,
            });
        }
    }
};
Effect_WatchThemDie_OnEnemyKilledEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_WatchThemDie_OnEnemyKilled")
], Effect_WatchThemDie_OnEnemyKilledEventHandlerScript);
exports.Effect_WatchThemDie_OnEnemyKilledEventHandlerScript = Effect_WatchThemDie_OnEnemyKilledEventHandlerScript;
